import { Component, OnInit, Input } from '@angular/core';
import { Real } from '../../../core/models/real.model';
import { Open } from '../../../core/models/open.model';
import { Employee } from '../../../core/models/employee.model';
import { ExecutionTimeRangeCommand } from '../../../core/models/executionTimeRangeCommand.model';

import { List } from '../../../core/models/list.model';
import { Provider } from '../../../core/models/provider.model';
import { EventsService } from 'src/app/core/services/events.service';

import { tap, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { TranslateService } from "@ngx-translate/core";

import { ModalController } from '@ionic/angular';
import { EmployeeModalComponent } from '../../employee-modal/employee-modal.component';
import { Router } from '@angular/router';

import * as moment from 'moment';

@Component({
  selector: 'app-exposed',
  templateUrl: './exposed.component.html',
  styleUrls: ['./exposed.component.scss'],
})
export class ExposedComponent implements OnInit {

  @Input() real: Real;
  @Input() open$: Observable<Open>;
  @Input() zajla: boolean;
  @Input() vip: boolean;
  
  public events$: Observable<Event[]|null>;

  currentUrl: string;
  
  pickSlotActive = false;

  now: string;

  constructor( private router: Router, private eventsService: EventsService, public translateService: TranslateService, private modalCtrl: ModalController ) { 
    this.currentUrl = this.router.url;
    this.now = moment().format();
  }

  ngOnInit() {

    this.events$ = this.eventsService.getEvents( ( this.currentUrl == '/vecerja-na-zajli' ), ( this.currentUrl == '/vip-gourmet-klub' ) ).pipe(
      tap(list => { console.log(list) })
    );

  }

  filterCommand( command: ExecutionTimeRangeCommand ) {
    return !command.absoluteIntervals
  }

  displayOpeningHoursDays( weeklyDays, absoluteIntervals, validForHolidaysArr, lang = 'sl' ) {

    console.log(weeklyDays);
    console.log(validForHolidaysArr);
    if ( !weeklyDays ) {

      if ( absoluteIntervals && absoluteIntervals[0] && absoluteIntervals[0][0] ) {
        return moment(absoluteIntervals[0][0]).lang( lang ).format('l');
      }

      return '';
    }

    const daysCaption = {
      'sl': [
        'pon',
        'tor',
        'sre',
        'čet',
        'pet',
        'sob',
        'ned',
        'prazniki',
        'in'
      ],
      'en': [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun',
        'Bank Holidays',
        'and'
      ],
      'de': [
        'Mon',
        'Die',
        'Mit',
        'Don',
        'Fre',
        'Sam',
        'Son',
        'Feiertage',
        'und'
      ],
      'it': [
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab',
        'dom',
        'giorni festivi',
        'e'

      ],
      'hr': [
        'pon',
        'uto',
        'sri',
        'čet',
        'pet',
        'sub',
        'ned',
        'praznici',
        'i'
      ],

    };

    if ( 5 === weeklyDays.length 
      && weeklyDays.includes(1)
      && weeklyDays.includes(2)
      && weeklyDays.includes(3)
      && weeklyDays.includes(4)
      && weeklyDays.includes(5)
    ) {
      return daysCaption[lang][0] + ' - ' + daysCaption[lang][4];
    }

    let result = weeklyDays.map( index => daysCaption[lang][(index - 1)] ).join(', ');

    if ( weeklyDays.includes(7) && validForHolidaysArr && validForHolidaysArr[0] && validForHolidaysArr[0][1] && 'for_set_weekdays_and_holidays' == validForHolidaysArr[0][1] ) {
      result += ' ' + daysCaption[lang][8] + ' ' + daysCaption[lang][7];
    }

    return result;
    
  }

  displayHours( dailyIntervals ) {

    if ( !dailyIntervals ) {
      return '';
    }

    let trimHour = function( hour ) {
       return hour.slice(0, -3);
    }

    return dailyIntervals.map( interval => trimHour(interval[0]) + ' - ' + trimHour(interval[1]) ).join(' ');

  }

  openEmployeeModal(employee: Employee) {

    this.modalCtrl.create({
      component: EmployeeModalComponent,
      cssClass: 'my-modal',
      componentProps: { 'employee': employee }
    })
    .then( modalEl => {
      modalEl.present();
      return modalEl.onDidDismiss();
    })
    .then( resultData => {

      /*if ( 'picked' === resultData.role && undefined !== resultData.data  ) {
        //redirect to shop
        this.router.navigate( [ '/restavracija', resultData.data.providerId, resultData.data.slug ] );
      }*/

    });
  }

  setPickSlotActive( value ) {
    this.pickSlotActive = value;
  }

}
